<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_vi"></a><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="tocb"><a id="page_vii"></a><a href="#/html/9780226670393_07_int#int">Introduction</a></p>
<p class="tocb"><a href="#/html/9780226670393_09_gui#gui">Guide for the Reader</a></p>
<p class="tocb"><a href="#/html/9780226670393_18_ch3#ch5">Statesman</a></p>
<p class="tocb"><a href="#/html/9780226670393_20_ch3com#ch6">Statesman Commentary</a></p>
<p class="tocb"><span href="#/html/9780226670393_21a_not#not" title="Link target outside of Sample">Notes</span></p>
<p class="tocb"><span href="#/html/9780226670393_22_bib#bib" title="Link target outside of Sample">Selected Bibliography</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226670393_04_toc.vue?6640b33e